// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "progress": {
      "column": {
        "default": 0.0,
        "name": "progress",
        "null": false,
        "type": "float"
      },
      "name": "progress",
      "selected_by_default": null,
      "translated": null
    },
    "result": {
      "column": null,
      "name": "result",
      "selected_by_default": null,
      "translated": null
    },
    "slug": {
      "column": {
        "default": null,
        "name": "slug",
        "null": true,
        "type": "string"
      },
      "name": "slug",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Jobler::Job",
  "collectionKey": "jobler/jobs",
  "collectionName": "jobler_jobs",
  "i18nKey": "jobler/job",
  "camelizedLower": "jobler::Job",
  "name": "JoblerJob",
  "nameDasherized": "jobler-job",
  "pluralName": "jobler_jobs",
  "ransackable_associations": [
    {
      "className": "Jobler::Result",
      "collectionName": null,
      "foreignKey": "job_id",
      "name": "results",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "ended_at",
      "column": {
        "default": null,
        "name": "ended_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "error_backtrace",
      "column": {
        "default": null,
        "name": "error_backtrace",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "error_message",
      "column": {
        "default": null,
        "name": "error_message",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "error_type",
      "column": {
        "default": null,
        "name": "error_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "host",
      "column": {
        "default": null,
        "name": "host",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "jobler_type",
      "column": {
        "default": null,
        "name": "jobler_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "locale",
      "column": {
        "default": null,
        "name": "locale",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_id",
      "column": {
        "default": null,
        "name": "old_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parameters",
      "column": {
        "default": null,
        "name": "parameters",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "port",
      "column": {
        "default": null,
        "name": "port",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "progress",
      "column": {
        "default": 0.0,
        "name": "progress",
        "null": false,
        "type": "float"
      }
    },
    {
      "name": "protocol",
      "column": {
        "default": null,
        "name": "protocol",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "slug",
      "column": {
        "default": null,
        "name": "slug",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "started_at",
      "column": {
        "default": null,
        "name": "started_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "job",
  "primaryKey": "id"
}

/** Frontend model for JoblerJob. */
export default class JoblerJob extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  progress() {
    return this.readAttributeUnderscore("progress")
  }

  /** @returns {boolean} */
  hasProgress() {
    const value = this.progress()

    return this._isPresent(value)
  }

  /** @returns {any} */
  result() {
    return this.readAttributeUnderscore("result")
  }

  /** @returns {boolean} */
  hasResult() {
    const value = this.result()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  slug() {
    return this.readAttributeUnderscore("slug")
  }

  /** @returns {boolean} */
  hasSlug() {
    const value = this.slug()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  enqueue(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "enqueue",
        primaryKey: this.primaryKey(),
        collectionName: "jobler_jobs",
        type: "member"
      },
      commandArgs
    ))
  }
}
